$(function(){

  console.log('search filter debug');
  
//   var spellings = [
//     { 'correct': 'tezt', variations: ['test','tesst'] }
    
//   ];
  
  var spellings = [
    	{ 'correct': 'Assam', variations: ['Asam'] },
        { 'correct': 'Bai Mu Dan', variations: ['Bai Mudan'] },
        { 'correct': 'Bao Zhong', variations: ['Baozhong', 'Pouchong'] },
        { 'correct': 'Big Red Robe', variations: ['Da Hong Pao'] },
        { 'correct': 'Chai', variations: ['Tai'] },
        { 'correct': 'Darjeeling', variations: ['Darjeling', 'Darjealing'] },
        { 'correct': 'Dragonwell', variations: ['Lung Ching','Longjing', 'Dragon\'s Well', 'Dragon Well'] },
        { 'correct': 'Genmaicha', variations: ['Genmacha', 'Genmai', 'Genmai cha', 'Popcorn tea', 'Toasted rice tea'] },
        { 'correct': 'Grey', variations: ['Gray'] },
        { 'correct': 'Hojicha', variations: ['Houjicha'] },
        { 'correct': 'Huang Shan Mao Feng', variations: ['Huangshan Maofeng'] },
        { 'correct': 'Jasmine', variations: ['Jasmin'] },
        { 'correct': 'Keemun', variations: ['Qimen'] },
        { 'correct': 'Matcha', variations: ['Macha'] },
        { 'correct': 'Maté ', variations: ['Mate'] },
        { 'correct': 'Bi Luo Chun', variations: ['Biluochun','Pi Lo Chun', 'Pilochun'] },
        { 'correct': 'Sheng', variations: ['Shung'] },
        { 'correct': 'Shu Puer', variations: ['Shou Puer','Sho Puer', 'Shoe Puer'] },
    	{ 'correct': 'Puer', variations: ['Puerh', 'Puer\'h', 'Pu\'erh', 'Pu\'er', 'Puer-h', 'Pu-erh', 'Pu-er', 'Pu erh'] },
        { 'correct': 'Silver Needles', variations: ['Baihao Yinzhen'] },
        { 'correct': 'Ti Kwan Yin', variations: ['Tieguanyin', 'Ti Kwun Yin', 'Ti Kuan Yin', 'Guanyin', 'Tie Guan Yin'] },
        { 'correct': 'Tung Ting', variations: ['Dong Ting', 'Dong Ding', 'Dongding', 'Dongting', 'Tungting'] }
    ];
  
  
  $('.search-form').submit(function( e ) {

    e.preventDefault();
    
    var queryText = $(this).find('.search-query').val();
    
    if ( queryText.length === 0 ) {
      return false;
    }
    

   	queryText = spellingCorrect( queryText );
    
    console.log( queryText );
    
    window.location = '/search?q=' + encodeURIComponent(queryText);
    
    
  });
  
  
  function spellingCorrect( query ) {
    
    
      var i = spellings.length;

      while ( i-- ) {

        var correctSpelling = spellings[ i ].correct,
            variations = spellings[ i ].variations;

        for ( var j = 0; j < variations.length; j++ ) {
			
          var p = makeSearchPattern( variations[ j ] );
          
          if ( p.test( query ) ) {
          	
            query = query.replace(p, function( match, p1, p2, p3 ) {
              	return [p1, correctSpelling, p3].join('');
              
            });
            
          }


        }

      }

	return query;

  }
  
  
            
  function makeSearchPattern( misspelling ) {
	
    return pattern = new RegExp('(^|\\s)(' + misspelling.replace(' ', '\\s') + ')(\\s|$)', 'gi');
            
  }
  
  
});